import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export var MetaMenuLink = function MetaMenuLink(_ref) {
  var link = _ref.link,
      variant = _ref.variant,
      style = _ref.style,
      className = _ref.className;

  if (!link) {
    return null;
  }

  return /*#__PURE__*/_jsx("a", {
    "aria-roledescription": link.description || link.title,
    className: classNames("btn btn-".concat(variant), className),
    href: link.path,
    title: link.title,
    style: style,
    children: link.title
  });
};